import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingDotsModule } from '../../core-ui/LoadingDots/LoadingDots.module';
import { WaitingIndicatorComponent } from '../../core-ui/WaitingIndicator/WaitingIndicator.component';
import { ScreenBlockComponent } from './ScreenBlock.component';

export const WaitingIndicatorModuleExports = [
    WaitingIndicatorComponent,
    ScreenBlockComponent
];

@NgModule({
    imports: [CommonModule, LoadingDotsModule],
    declarations: [...WaitingIndicatorModuleExports],
    exports: [...WaitingIndicatorModuleExports],
    providers: []
})
export class WaitingIndicatorModule {}
